export const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export function formatDate(iso) {
  try {
    const d = new Date(iso + "T00:00:00");
    return d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
  } catch {
    return iso;
  }
}

export function formatDateLong(iso) {
  try {
    const d = new Date(iso + "T00:00:00");
    return d.toLocaleDateString(undefined, { weekday: "long", year: "numeric", month: "long", day: "numeric" });
  } catch {
    return iso;
  }
}

export const STATUS_META = {
  pending: { label: "Pending", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  accepted: { label: "Accepted", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  denied: { label: "Denied", cls: "bg-red-100 text-red-700 border-red-200" },
  cancelled: { label: "Cancelled", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  completed: { label: "Completed", cls: "bg-sky-100 text-sky-800 border-sky-200" },
};

export function initials(name = "") {
  return name.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase();
}
